import { FC, ReactNode } from "react";
import { useStyles } from "./ProductLayout.styles";
import { ToastContainer, toast } from "react-toastify";
import {
  Icon,
  IconCoin,
  IconCoins,
  IconFileStack,
  IconNotebook,
  IconPennant,
  IconTruck,
  IconDevicesCheck,
  IconFlag,
  IconMoneybag,
  IconBuildingWarehouse,
  IconUsers,
  IconHome,
} from "@tabler/icons-react";
import AdminNavBar, {
  IMenuItem,
} from "../../components/AdminNavBar/AdminNavBar";

interface IProps {
  content: ReactNode;
}

const menus: IMenuItem[] = [
  {
    label: "Dashboard",
    path: "/pm-dashboard/activenotes",
    icon: IconHome,
  },
  {
    label: "Campaign",
    submenu: [
      { label: "Create new", path: "/create-campaign" },
      { label: "Campaign List", path: "/campaign-list" },
    ],
    icon: IconPennant,
  },
  {
    label: "SKU",
    submenu: [
      { label: "Verify SKU Loans", path: "/verify-sku-loans" },
      { label: "Loan Details", path: "/loan-details" },
    ],
    icon: IconFileStack,
  },
  {
    label: "Note",
    submenu: [
      { label: "Create", path: "/structured-note/sku-pooling" },
      { label: "List", path: "/note-list" },
    ],
    icon: IconNotebook,
  },
  {
    label: "Issuer",
    path: "/issuer",
    icon: IconTruck,
  },
  {
    label: "Withdrawal",
    path: "/withdrawal",
    icon: IconCoins,
  },
  {
    label: "Virtual Accounts",
    path: "/virtual-accounts",
    icon: IconCoin,
  },

  {
    label: "External Accounts",
    path: "/external-accounts",
    icon: IconMoneybag,
  },
  {
    label: "Inventory/Orders",
    submenu: [
      { label: "Inventory", path: "/inventory" },
      { label: "Orders", path: "/orders" },
      { label: "Fund Pull", path: "/fund-pull" },
    ],
    icon: IconBuildingWarehouse,
  },
  {
    label: "Merchant Configuration",
    submenu: [
      { label: "Fund Pull / Auto Refund", path: "/fund-pull-auto-refund" },
    ],
    icon: IconUsers,
  },
  {
    label: "Audit",
    path: "/audit",
    icon: IconDevicesCheck,
  },
  {
    label: "Feature Flags",
    path: "/feature-flags",
    icon: IconFlag,
  },
];

const ProductLayout: FC<IProps> = ({ content }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.mainContainer}>
      <AdminNavBar menus={menus} role="Product Manager" />
      <ToastContainer />

      <div className={classes.hero}>{content}</div>
    </div>
  );
};

export default ProductLayout;
